import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

import { DestroySubscriptionsService } from '@libs/src/destroy-subscription/destroy-subscription.service';

import { fadeInEnter } from '@libs/src/animations/animations';
import { AccountGoal } from '@libs/src/models/account-goal.model';
import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';
import { Tenant } from '@libs/src/tenant/tenant.interface';
import { getMembership } from '@main-client/src/app/account/account.helpers';

import get from 'lodash-es/get.js';

enum viewModes {
  overview = 'overview',
  setGoals = 'setGoals',
}

@Component({
  animations: [fadeInEnter],
  providers: [DestroySubscriptionsService],
  selector: 'app-user-onboarding-view-goal-setting',
  templateUrl: './user-onboarding-view-goal-setting.component.html',
})
export class UserOnboardingViewGoalSettingComponent implements OnChanges {
  @Input() group: Group;
  @Input() tenant: Tenant;
  @Input() user: Account;
  @Output() navigateToNextView = new EventEmitter();
  viewModes = viewModes;
  viewMode = viewModes.overview;
  isLoading = false;
  areGoalFormsValid = true;

  ngOnChanges() {
    const accountGroupMembership = getMembership(
      this.user.groups,
      this.group._id,
    );
    const accountGoals = get(
      accountGroupMembership,
      'goals',
      [],
    ) as AccountGoal[];
    this.viewMode = accountGoals.length
      ? viewModes.setGoals
      : viewModes.overview;
  }
}
